import { render, staticRenderFns } from "./PlanningIndex.vue?vue&type=template&id=48221750&scoped=true"
import script from "./PlanningIndex.vue?vue&type=script&lang=js"
export * from "./PlanningIndex.vue?vue&type=script&lang=js"
import style0 from "./PlanningIndex.vue?vue&type=style&index=0&id=48221750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48221750",
  null
  
)

export default component.exports